import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {checkRiddleAnswer } from "../../ducks/duck-game";
import {addModalWindow, addToast} from "../../ducks/duck-screen";

import GameScreen from "./game-screen";

// import { updateCompletedLogo } from "../../ducks/duck-user";

function GameScreenContainer(props) {
	return <GameScreen {...props} />;
}

GameScreenContainer.propTypes = {
	currentRiddleRange: PropTypes.string.isRequired,
	activeLogoIndex: PropTypes.number.isRequired,
	gameType: PropTypes.string.isRequired,
	isCheckingAnswer: PropTypes.bool.isRequired,
	isModalOpen: PropTypes.bool.isRequired,
	isSound: PropTypes.bool.isRequired,
	isVibrate: PropTypes.bool.isRequired,

	userRiddles: PropTypes.object.isRequired,
	activeLogo: PropTypes.object.isRequired,

	push: PropTypes.func.isRequired,
	checkRiddleAnswer: PropTypes.func.isRequired,
	addToast: PropTypes.func.isRequired,
	addModalWindow: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
	const gameType = state.gameReducer.gameType;
	const settings = state.userReducer.settings;

	let isSound = false;
	if(settings && settings.isSound){
		isSound = true;
	}

	let isVibrate = false;
	if(settings && settings.isVibrate){
		isVibrate = true;
	}

	return {
		currentRiddleRange: state.screenReducer.currentRiddleRange,
		activeLogoIndex: state.screenReducer.activeLogoIndex,
		gameType,
		userRiddles: state.gameReducer.userRiddles,
		activeLogo : state.screenReducer.activeLogo,
		isCheckingAnswer: state.gameReducer.isCheckingAnswer,
		isSound,
		isVibrate,
		isModalOpen: state.screenReducer.modalList.length > 0,
	};
}

export default connect(mapStateToProps,
	{ checkRiddleAnswer, addToast, addModalWindow })( GameScreenContainer );
